// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__3zbp9","list":"styles_list__2rV44","item":"styles_item__2wmlO"};